import { useEffect, useRef } from 'react';

const problems = [
  {
    icon: '📵',
    title: 'Calls Going to Voicemail',
    body: "Every missed call after 6pm is a job your competitor just booked.",
  },
  {
    icon: '😤',
    title: 'Leads Going Cold',
    body: "By the time you call back, they've moved on. Speed wins jobs.",
  },
  {
    icon: '💸',
    title: 'Ads With No System',
    body: "Spending on leads with no automated way to convert them.",
  },
];

export default function Problem() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );
    const reveals = sectionRef.current?.querySelectorAll('.reveal');
    reveals?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative py-16 px-5 overflow-hidden"
      style={{ backgroundColor: '#080F0C' }}
    >
      {/* Subtle top separator */}
      <div
        className="absolute top-0 left-0 right-0 h-px"
        style={{ background: 'linear-gradient(to right, transparent, rgba(10,92,68,0.5), transparent)' }}
      />

      <div className="max-w-5xl mx-auto">
        {/* Headline */}
        <div className="reveal opacity-0 mb-8" style={{ transitionDelay: '0ms' }}>
          <h2
            className="font-bebas text-brand-text text-center"
            style={{ fontSize: 'clamp(40px, 12vw, 52px)', letterSpacing: '0.02em' }}
          >
            Sound Familiar?
          </h2>
        </div>

        {/* Problem Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {problems.map((p, i) => (
            <div
              key={i}
              className="reveal opacity-0 rounded-xl p-5 relative overflow-hidden cursor-default"
              style={{
                transitionDelay: `${i * 120}ms`,
                backgroundColor: '#0d1a16',
                borderLeft: '3px solid #e53935',
                border: '1px solid rgba(229,57,53,0.25)',
                borderLeftWidth: '3px',
                borderLeftColor: '#e53935',
              }}
            >
              {/* Subtle bg glow */}
              <div
                className="absolute top-0 right-0 w-24 h-24 rounded-full pointer-events-none"
                style={{ background: 'radial-gradient(circle, rgba(229,57,53,0.06) 0%, transparent 70%)', transform: 'translate(30%, -30%)' }}
              />
              <div className="flex items-start gap-4">
                <span className="text-2xl mt-0.5 flex-shrink-0">{p.icon}</span>
                <div>
                  <h3 className="font-dm font-bold text-brand-text mb-1" style={{ fontSize: '16px' }}>
                    {p.title}
                  </h3>
                  <p className="font-dm text-brand-grey text-sm leading-relaxed">
                    {p.body}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Closing */}
        <div className="reveal opacity-0 mt-8 text-center" style={{ transitionDelay: '400ms' }}>
          <p className="font-dm italic text-brand-grey text-sm">
            There's a better way.{' '}
            <a
              href="https://apex-emerald-ai.com/contact"
              className="cursor-pointer transition-colors duration-200"
              style={{ color: '#AAFF45' }}
            >
              Try it today — completely free.
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
